import { render } from "./StudentsList.vue?vue&type=template&id=24af5fce&scoped=true&ts=true"
import script from "./StudentsList.vue?vue&type=script&lang=ts"
export * from "./StudentsList.vue?vue&type=script&lang=ts"

import "./StudentsList.vue?vue&type=style&index=0&id=24af5fce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24af5fce"]])

export default __exports__